import React from 'react'
import classNames from 'classnames'
import { HiChevronLeft }  from "react-icons/hi"
import AllIcons from 'constants/images.constant'

const Prev = props => {

	const { currentPage, pagerClass, onPrev } = props

	const disabled = currentPage <= 1 

	const onPrevClick = e => {
		if(disabled) {
			return 
		}
		onPrev(e)
	}

	const pagerPrevClass = classNames(
		pagerClass.default, 
		'pagination-pager-prev', 
		disabled ? pagerClass.disabled : pagerClass.inactive
	)

	return (
		<span className={pagerPrevClass} onClick={onPrevClick}>
			<img src={AllIcons.ArrowLeft} width={5} height={9} alt="ArrowLeft icon" />
		</span>
	)
}

export default Prev
